import {
  IconAlertTriangle,
  IconArchive,
  IconArrowRight,
  IconBox,
  IconBrandGithub,
  IconBrandTwitter,
  IconCamera,
  IconChartBar,
  IconCheck,
  IconChecklist,
  IconChevronLeft,
  IconChevronRight,
  IconCircleCheck,
  IconClipboardText,
  IconClock,
  IconCommand,
  IconCreditCard,
  IconCrown,
  IconDeviceDesktop,
  IconDeviceLaptop,
  IconDotsVertical,
  IconFile,
  IconFileDescription,
  IconFileSearch,
  IconFileText,
  IconFolder,
  IconHelpCircle,
  IconLayoutDashboard,
  IconLayoutGrid,
  IconLayoutKanban,
  IconListDetails,
  IconLoader2,
  IconLock,
  IconLogin,
  IconMoon,
  IconPackage,
  IconPalette,
  IconPhoto,
  IconPizza,
  IconPlus,
  IconProps,
  IconReceipt,
  IconSettings,
  IconStar,
  IconSun,
  IconTrash,
  IconTruck,
  IconUser,
  IconUserCircle,
  IconUserCog,
  IconUserEdit,
  IconUserX,
  IconUsers,
  IconUserShield,
  IconMapPin,
  IconBuildingWarehouse,
  IconFileAnalytics,
  IconShield,
  IconUsersGroup,
  IconX,
  IconClipboardCheck,
  IconScan,
  IconTool,
  IconBuilding,
  IconInfoCircle,
  IconAlertCircle,
  IconFlask,
  IconLanguage,
  IconTruckDelivery
} from '@tabler/icons-react';

export type Icon = React.ComponentType<IconProps>;

export const Icons = {
  // General
  logo: IconCommand,
  spinner: IconLoader2,
  close: IconX,
  check: IconCheck,
  add: IconPlus,
  trash: IconTrash,
  warning: IconAlertTriangle,
  arrowRight: IconArrowRight,
  help: IconHelpCircle,
  ellipsis: IconDotsVertical,
  chevronLeft: IconChevronLeft,
  chevronRight: IconChevronRight,

  // Theme
  sun: IconSun,
  moon: IconMoon,
  laptop: IconDeviceLaptop,
  palette: IconPalette,

  // User
  user: IconUser,
  account: IconUserCircle,
  profile: IconUser,
  user2: IconUserCircle,
  userPen: IconUserEdit,
  employee: IconUserX,
  login: IconLogin,

  // Legacy / template (kept for reference)
  dashboard: IconLayoutDashboard,
  product: IconBox,
  kanban: IconLayoutKanban,
  post: IconFileText,
  page: IconFile,
  media: IconPhoto,
  billing: IconCreditCard,
  pizza: IconPizza,
  settings: IconSettings,
  github: IconBrandGithub,
  twitter: IconBrandTwitter,
  workspace: IconFolder,
  teams: IconUsers,
  pro: IconCrown,
  exclusive: IconStar,

  // Archiving workflow
  registration: IconClipboardText,
  camera: IconCamera,
  sticking: IconListDetails,
  review: IconCircleCheck,
  packing: IconPackage,
  securitySeal: IconLock,
  shipping: IconTruck,

  // Tracking & logistics
  deliveryLog: IconChecklist,
  sealTracking: IconClock,
  shipmentStatement: IconReceipt,

  // Administration
  supervisor: IconLayoutGrid,
  reports: IconChartBar,
  auditLog: IconFileSearch,
  formManagement: IconFileDescription,
  boxManagement: IconArchive,
  userManagement: IconUserCog,

  // System settings
  roles: IconShield,
  users: IconUsersGroup,
  boxTypes: IconArchive,
  containerTypes: IconBox,
  admin: IconUserShield,
  locations: IconMapPin,
  storageLocations: IconBuildingWarehouse,
  devices: IconDeviceDesktop,
  systemLogs: IconFileAnalytics,

  // Internal Lab
  boxReception: IconClipboardCheck,
  handoverScanning: IconScan,

  // Enterprise
  clients: IconBuilding,

  // Oman Repair
  wrench: IconTool,

  // Warehouse
  warehouseAssignment: IconBuildingWarehouse,

  // Configurations sub-pages
  rejectionReasons: IconAlertCircle,
  labs: IconFlask,

  // Drivers
  drivers: IconTruckDelivery,

  // About
  about: IconInfoCircle,

  // Localization
  languages: IconLanguage,

  // Search
  search: IconFileSearch
};
